import { Campaign } from "../types";

export const NEWS_MODAL = {
  pill: "Novidades do Acertei",
  title: "Fique por dentro das novidades",
  subtitle: "Confira concursos com edital aberto, novos planos e atualizações da plataforma antes de continuar.",
};

export const CAMPAIGNS: Campaign[] = [
  {
    id: "cfo-cbmgo-2026",
    tag: "Novo plano",
    tagIcon: "file-text",
    title: "CFO CBMGO 2026",
    description: "Questões que já caíram • estatísticas em tempo real ",
    href: "/planos?plano=cadete-aluno-oficial-cbmgo",
    icon: "flame",
    startsAt: "2026-09-16",
    endsAt: "2026-11-30",
  },
  {
    id: "soldado-pmgo-2026-09",
    tag: "Novo plano",
    tagIcon: "megaphone",
    title: "Pacote de questões Soldado Combatente (PMGO)",
    description: "Questões que já caíram • estatísticas em tempo real • R$ 29,90/mês",
    href: "/planos?plano=soldado-combatente-pmgo",
    icon: "shield",
    startsAt: "2026-09-16",
    endsAt: "2026-10-31",
  },
];
